GroupDetailToolbarCtrl = ($scope ,$filter ,$location ,$route ,$ngConfirm ,groupRegisDataService ,groupDetailToolbarService ,GroupMemberService ,formCopyService ) ->
  userId = $scope.userInfo.user_id
  groupId = $scope.groupDetail.id
  prepareMess =  $filter('translate')('_GROUP.IN_PREPARE')

  $scope.member = $scope.groupStatus.role == 'member' && $scope.groupStatus.status == 'approved'
  $scope.admin  = $scope.groupStatus.role == 'admin'
  $scope.requestPending = $scope.groupStatus.status == 'pending'

  $scope.requestGroup = ->
    if userId == '' || groupId == ''
      return
    params =
      user_id : userId
      group_id : groupId
    groupRegisDataService.joinGroup(params).finally ->
      mess = $filter('translate')('_GROUP.TOOLBAR.REQUEST_MESS_JOIN_GROUP')
      $ngConfirm(mess)
      $route.reload()

  $scope.displayMemberRequest = ->
    params =
      id : groupId
      page_size : 1
      page : 1
      status : 'pending'
    GroupMemberService.listMemRequest(params).then (data) ->
      $scope.numBadge = data.total

  $scope.goToListMember = ->
    $location.path("/groups/#{groupId}/members/list-members")

  $scope.gotoInfoPage = ->
    $location.path("/groups/#{groupId}/information")

  $scope.leaveGroup = ->
    if userId == '' || groupId == ''
      return
    params =
      user_id : userId
      group_id : groupId
    mess = $filter('translate')('_GROUP.TOOLBAR.CONFIRM_MESS_LEAVE_GROUP')
    errorMess = $filter('translate')('_GROUP.TOOLBAR.NOT_ALLOWED_LEAVE_GROUP')
    config =
      title: ''
      content: mess
      buttons:
        Cancel:
          text: $filter('translate')('_GROUP_EVENT.CANCEL')
        OkButton:
          text: 'OK'
          action: ->
            groupDetailToolbarService.leaveGroup(params)
              .then (resp) ->
                $location.path('/groups')
              .catch (resp) ->
                $ngConfirm(errorMess)
    $ngConfirm(config)

  $scope.dataURL = (id) ->
    extUrl = "/groups/join?id=#{id}"
    url = $location.absUrl().replace($location.url() , extUrl)

  $scope.copyFunc =  ->
    formCopyService.copy($scope.dataURL(groupId))
    mess = $filter('translate')('_GROUP.TOOLBAR.COPY_MESS_URL')
    $ngConfirm(mess)

  $scope.displayMemberRequest()

GroupDetailToolbarCtrl.$inject = [
  '$scope'
  '$filter'
  '$location'
  '$route'
  '$ngConfirm'
  'groupRegisDataService'
  'groupDetailToolbarService'
  'GroupMemberService'
  'formCopyService'
]

module.exports = GroupDetailToolbarCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-detail-toolbar/group-detail-toolbar-controller.coffee